module.exports = __webpack_public_path__ + "Flag-84.0906dd97360dc0fff4b11f68c016fa79.svg";